import { memo } from 'react';
import { RenderHtml } from '@betty/moonlight';
import { DepositPromoInfoProps } from './DepositPromoInfo.types';

function DepositPromoInfo({ info }: DepositPromoInfoProps) {
  return <RenderHtml html={info} variant="body-m" color="darkSurfacePrimary" />;
}

export default memo(DepositPromoInfo);
